import React from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import "../IntroSection/about.css";
import { Fade, Slide, Zoom } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import { StyledLink } from "../navBar/Brand";

const Introduction = () => {
  //  const handleDownloadCV = () => {
  //   const downloadLink = document.createElement('a');
  //   downloadLink.href = 'public/assets/pdf/Gaurav_CV.pdf'; // Replace with the actual path to your CV file
  //   downloadLink.download = 'Gaurav_CV.pdf'; // Set the desired name for the downloaded file
  //   downloadLink.click();
  // };

  return (
    <Container className="aboutMe">
      <div>
        <Slide direction="left" delay={".5s"}>
          <Fade delay={"1s"}>
            <h5>
              <b>Hello, I'm Gaurav Bhardwaj</b>, a 3rd-year Undergraduate at IIT
              Kharagpur, specializing in Electronics and Electrical
              Communication Engineering. My passion lies in development, and I
              take pride in creating impactful web and mobile applications. With
              experience in Django Framework web development at the
              Entrepreneurship Cell, alongside crafting MERN stack web apps and
              React Native mobile apps, I've developed expertise in both
              domains. Competitive Programming nurtures my logical thinking and
              fuels my drive for continuous improvement. My vision is to
              contribute to innovative development projects, shaping a better
              future through technology.
              <br />
              <br />
              <b>Let's Connect!</b> I'm enthusiastic about exploring
              collaboration opportunities and discussing anything related to
              development and technology. Feel free to reach out, and let's
              create exciting possibilities together!
            </h5>
          </Fade>
        </Slide>
        <Fade delay={"3s"}>
          <div className="btns">
            <Button variant="primary mt-4">
              <a
                target="blank"
                href="https://drive.google.com/file/d/1ErNCIXS8wtVjLXZfrR3X7vScOj1_4PC9/view?usp=drive_link"
                style={{ color: "white", textDecoration: "none" }}
                download
              >
                Download CV
              </a>
            </Button>
            <Button variant="success mt-4">Contact Me</Button>
          </div>
        </Fade>
      </div>
    </Container>
  );
};

function About() {
  return (
    <Container
      fluid
      className="aboutSection"
      style={{ minHeight: "fit-content" }}
    >
      <Container className="aboutContent">
        <Row>
          <Zoom>
            <Col className="titleRow">
              <h2 className="animate__animated animate__backInUp">
                Know the person behind the Code : Gaurav Bhardwaj
              </h2>
              <hr className="hr" />
            </Col>
          </Zoom>
        </Row>
        <Row className="content-wrapper" style={{ flexWrap: "wrap-reverse" }}>
          <Col className="text-white introContent" lg="7">
            <Fade>
              <Introduction />
            </Fade>
          </Col>
          <Col
            className="animate__animated animate__backInRight imgDev text-center"
            lg="5"
          >
            <Fade delay={"2s"}>
              <Slide direction="right" delay={"1s"}>
                <Image
                  className="animate__animated animate__backInRight developer"
                  src="./assets/images/developer.png"
                  height={400}
                  width={400}
                />
                <Fade delay={"3s"}>
                  <Button variant="btn btn-secondary btn-block mt-1 mb-4">
                    <a
                      target="blank"
                      href="https://drive.google.com/file/d/1ErNCIXS8wtVjLXZfrR3X7vScOj1_4PC9/view?usp=drive_link"
                      style={{ color: "white", textDecoration: "none" }}
                      download
                    >
                      Check out my Blog Application
                    </a>
                  </Button>
                </Fade>
              </Slide>
            </Fade>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default About;
